import React from 'react';
import {
  Box, Typography,
} from '@mui/material';
import { ParallaxProvider } from 'react-scroll-parallax';
import hug from '../files/images/cocktail.avif';
import nam from '../files/images/nam.avif';
import PhotoGallery from './PhotoGallery';
import Footer from './Footer';
import Background from './Background2';
import Header from './Header2';
import CagnotteLink from './rsvp/CagnotteLink';

function Home({ rsvpSection, contactSection }) {
  return (
    <ParallaxProvider>
      <>
        <Background refToSwitch={rsvpSection} />

        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Header contactSection={contactSection} />
          {/* <Box sx={{
            py: 6,
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            backgroundColor: 'terracota2.main',
            px: 1,
          }}
          >
            <Typography
              sx={{
                typography: {
                  xs: 'h5',
                  sm: 'h4',
                  md: 'h3',
                },
                textAlign: 'center',
                color: '#FFFFFF',
              }}
            >
              WE DID IT !
            </Typography>
          </Box> */}

          <PhotoGallery />

          <Box
            sx={{
              width: '100%',
              height: '250px',
              overflow: 'hidden',
              position: 'relative',
            }}
          />

          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            py: 12,
            backgroundColor: 'background.default',
            position: 'relative',
            overflow: 'visible',
          }}
          >
            {/* Inclined nam image with dropdown shadow */}
            <Box
              sx={{
                position: 'absolute',
                top: {
                  xs: '-50px',
                  sm: '-75px',
                  md: '-100px',
                },
                right: {
                  xs: '-20px',
                  sm: '-20px',
                  md: '-40px',
                },
                transform: 'rotate(-15deg)',
                zIndex: 1,
                filter: 'drop-shadow(0 10px 20px rgba(0, 0, 0, 0.3))',
                width: {
                  xs: '200px',
                  sm: '250px',
                  md: '400px',
                },
              }}
            >
              <img
                src={nam}
                alt="Nam decoration"
                style={{
                  width: '100%',
                  height: 'auto',
                }}
              />
            </Box>

            <Box sx={{
              zIndex: 10,
            }}
            >
              <CagnotteLink />
            </Box>
          </Box>
          <Box
            sx={{
              width: '100%',
              height: '250px',
              overflow: 'hidden',
              position: 'relative',
            }}
          />

          <Box
            sx={{
              py: 12,
              display: 'flex',
              flexDirection: 'column',
              backgroundColor: 'primary.main',
              px: 1,
              gap: 6,
            }}
          >
            <Typography sx={{
              typography: {
                xs: 'h6',
                md: 'h4',
              },
              color: 'background.default',
            }}
            >
              À bientôt !
            </Typography>
          </Box>

          <div style={{ position: 'relative', width: '100%', height: '750px' }} ref={contactSection}>
            <img src={hug} alt="bg" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            <Box
              sx={{
                position: 'absolute',
                top: '75%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                color: 'white',
                fontSize: '24px',
                display: 'flex',
                flexDirection: 'column',
                gap: 3,
                backgroundColor: 'rgba(255, 255, 255, 0.7)',
              }}
            >
              <Footer />
            </Box>
          </div>
        </Box>
      </>
    </ParallaxProvider>
  );
}

export default Home;
